import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
// Dashboard is the landing route — needed on virtually every cold entry, so it
// ships in the main bundle (NOT lazy) and renders directly with the shell.
// It is local-first and renders instantly with the shell (no suspending queries).
import { Dashboard } from "@/features/dashboard/components/dashboard";

export const indexRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/",
  component: Dashboard,
});
